import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AlertController, ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-addtiratore',
  templateUrl: './addtiratore.page.html',
  styleUrls: ['./addtiratore.page.scss'],
})
export class AddTiratorePage implements OnInit {
  myform: FormGroup;
  constructor(private fireStore: AngularFirestore, private formBuilder: FormBuilder, public alertController: AlertController, private modalC: ModalController) {


  }
  utenti = [];
  @Input() tiratore;
  // @Input() nome;
  // @Input() data
  // @Input() n_bersagli
  // @Input() user_id;
  // @Input() user_invited;


  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.myform = new FormGroup({
      // nome: new FormControl(),
      tiratorelibero: new FormControl(),
    });
    //console.logthis.tiratore);
    this.fireStore.collection<any>('userProfile').snapshotChanges().subscribe(actions => {

      let objform = {};
      this.utenti = actions.map((el: any, index) => {
        let data = el.payload.doc.data();
        //console.logdata);
        return data;
      }).sort(function (a, b) {

        var nameA = a.cognome.toUpperCase() + a.nome.toUpperCase(); // ignora maiuscole e minuscole
        var nameB = b.cognome.toUpperCase() + b.nome.toUpperCase(); // ignora maiuscole e minuscole
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      })

      // setTimeout(() => {
      //   this.myform = new FormGroup(objform);
      // }, 800);


      // this.form = this.formBuilder.group({

      // });

    });


  }

  sel_libero() {
    //console.logthis.myform.value.tiratorelibero);
    let obj = { nome: '', cognome: this.myform.value.tiratorelibero, email: '', uid: '' };
    this.modalC.dismiss(obj);
  }
  change(ev) {

  }
  close() {
    this.modalC.dismiss();
  }
  seleziona(tiratore) {
    // var arr_invitati = [];
    //   //console.logthis.myform.value);
    // for(let a in this.myform.value){
    //   if(this.myform.value[a]==true)
    //     arr_invitati.push(a);
    // }

    //   //console.logarr_invitati);  


    // // this.utenti.map(el => {
    // //   if (el.isChecked == true) {
    // //     arr_invitati.push(el.id);
    // //   }
    // //   return el;
    // // });
    // // //console.logarr_invitati);
    // this.fireStore.collection<any>('gara').doc(this.id).update({ user_invited: arr_invitati }).then(() => {

    //   this.presentAlert();
    //   this.modalC.dismiss();
    // })


    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalC.dismiss(tiratore);

  }

  async presentAlert() {
    let obj_alert = {
      header: 'Inviti',
      subHeader: 'Gara',
      message: 'Gli inviti sono stati salvati con successo',
      buttons: ['OK']
    }
    const alert = await this.alertController.create(obj_alert);

    await alert.present();
  }
}
